import React, { ReactElement } from 'react';
import { Input, Label } from 'reactstrap';
import {
  DealerPIIType,
  DealerPIITypes,
  FormNodeDealerPIIModel,
} from '../../../../../shared/dealer';
import { TranslationConsumer } from '../../../../translations';
import { AbstractElementEditor, UpdateFormProps } from './AbstractElementEditor';

export class DealerPiiEditor extends AbstractElementEditor<FormNodeDealerPIIModel> {
  public getDescription(): string {
    return 'Dealer PII';
  }

  public getName(): string {
    return 'Dealer PII';
  }

  public getIcon(): string {
    return 'person';
  }

  public override getDefaultValues(): Partial<Omit<FormNodeDealerPIIModel, 'id' | 'type'>> {
    return {
      subType: 'name',
      displayName: 'Business Name',
    };
  }

  public override getUpdateForm({
    node,
    update,
  }: UpdateFormProps<FormNodeDealerPIIModel>): ReactElement {
    // TODO: This should be a component of itself
    return (
      <TranslationConsumer>
        {(tr) => (
          <>
            <Label for="dealerPIIType">{tr!.ts('type')}</Label>
            <Input
              defaultValue={node.subType}
              id="dealerPIItype"
              onChange={(e) => {
                update({ ...node, subType: e.target.value as DealerPIIType });
              }}
              type="select"
            >
              {DealerPIITypes.map((t) => (
                <option key={t} value={t}>
                  {t}
                </option>
              ))}
            </Input>
            <Label for="dealerPIIDisplay">{tr!.ts('common.display_name')}</Label>
            <Input
              defaultValue={node.displayName ?? ''}
              id="dealerPIIDisplay"
              onChange={(e) => {
                update({ ...node, displayName: e.target.value });
              }}
              type="text"
            />
          </>
        )}
      </TranslationConsumer>
    );
  }
}
